import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutSMC3ProfileList extends Layout {
    labelSearchSMC3onfigurationProfiles: Label;
    sourceSMC3ConfigProfile: DataSource;
    tableP44Profile: Table;
}
